import { useState } from "react";
import { ListSelectorModal, ListSelectorItem } from "@bonliva-crm/ui";
import {
  useGetUserSelectorModalUsersQuery,
  UserSelectorModalUserFragment
} from "@bonliva-crm/graphql";

export type UserSelectorModalProps = {
  open: boolean;
  multi: boolean;
  onClose: () => void;
  onSelected: (selected: UserSelectorModalUserFragment[]) => void;
};

export function UserSelectorModal(props: UserSelectorModalProps) {
  const [items, setItems] = useState<ListSelectorItem[]>([]);

  const { data, loading } = useGetUserSelectorModalUsersQuery({
    fetchPolicy: "cache-and-network",
    skip: !props.open,
    onCompleted: (data) => {
      const list: ListSelectorItem[] = [];

      for (const user of data.users) {
        if (user.Teams.length > 0) {
          for (const team of user.Teams) {
            list.push({
              group: team,
              label: user.Name,
              value: user._id
            });
          }
        } else {
          list.push({
            label: user.Name,
            value: user._id
          });
        }
      }

      setItems(list);
    }
  });

  return (
    <ListSelectorModal
      open={props.open}
      items={items}
      multi={props.multi}
      title="Select Users"
      withSearch
      loading={loading}
      onClose={props.onClose}
      onSelected={(ids) => {
        const items = data.users.filter((u) => ids.includes(u._id));
        props.onSelected(items);
      }}
    />
  );
}
